var FeatureType = /* @__PURE__ */ function(FeatureType2) {
  FeatureType2["Regular"] = "REGULAR";
  FeatureType2["Highlighted"] = "HIGHLIGHTED";
  return FeatureType2;
}({});
var BillingPeriod = /* @__PURE__ */ function(BillingPeriod2) {
  BillingPeriod2["Monthly"] = "month";
  BillingPeriod2["Yearly"] = "year";
  return BillingPeriod2;
}({});
var ItemType = /* @__PURE__ */ function(ItemType2) {
  ItemType2["Feature"] = "FEATURE";
  ItemType2["Separator"] = "SEPARATOR";
  return ItemType2;
}({});
var BillingType = /* @__PURE__ */ function(BillingType2) {
  BillingType2["Recurring"] = "RECURRING";
  BillingType2["Lifetime"] = "LIFETIME";
  return BillingType2;
}({});
const StoreNames = {
  app_store: "Apple App Store",
  play_store: "Google Play Store",
  promotional: "Fabric promotion",
  stripe: "Fabric web"
};
const BriefStoreNames = {
  app_store: "App Store",
  play_store: "Play Store",
  promotional: "Promotion",
  stripe: "Stripe"
};
const StoreToAppName = {
  app_store: "Fabric iOS app",
  play_store: "Fabric Android app",
  stripe: "Fabric website",
  promotional: "Fabric promotion"
};
var PurchaseErrorCode = /* @__PURE__ */ function(PurchaseErrorCode2) {
  PurchaseErrorCode2["GENERIC"] = "GENERIC";
  PurchaseErrorCode2["HAS_LIFETIME"] = "HAS_LIFETIME";
  PurchaseErrorCode2["SAME_PLAN"] = "SAME_PLAN";
  PurchaseErrorCode2["NATIVE_TIER_MISMATCH"] = "NATIVE_TIER_MISMATCH_SAME_USER";
  PurchaseErrorCode2["CANCELLED"] = "CANCELLED";
  return PurchaseErrorCode2;
}({});
const PurchaseErrorMessages = {
  ["GENERIC"]: () => "An error occurred while trying to purchase the plan. Please try again.",
  ["HAS_LIFETIME"]: () => "Unable to change from lifetime plan.",
  ["SAME_PLAN"]: () => "You are already subscribed to this plan.",
  ["NATIVE_TIER_MISMATCH_SAME_USER"]: (store) => `The ${store === "app_store" ? "App Store" : "Play Store"} account associated with this device is already subscribed to a plan. Please use the same account to manage your subscription.`,
  ["CANCELLED"]: () => "User cancelled the purchase."
};
class PurchaseError extends Error {
  constructor(code, store) {
    super(PurchaseErrorMessages[code](store));
    this.code = code;
    this.name = "PricingError";
  }
}

export { BillingPeriod, BillingType, BriefStoreNames, FeatureType, ItemType, PurchaseError, PurchaseErrorCode, PurchaseErrorMessages, StoreNames, StoreToAppName };
//# sourceMappingURL=pricing.types.js.map
